import { getTrainingRecordings, deleteRecording, getDownloadLink, downloadRecording } from '../../api/training.api';

export const GET_TRAINING_RECORDINGS = 'GET_TRAINING_RECORDINGS';
export const GET_TRAINING_RECORDINGS_SUCCESS = 'GET_TRAINING_RECORDINGS_SUCCESS';
export const GET_TRAINING_RECORDINGS_ERROR = 'GET_TRAINING_RECORDINGS_ERROR';

export const SET_TRAINING_RECORDING_PREVIEW = 'SET_TRAINING_RECORDING_PREVIEW';
export const SET_TRAINING_CHILD_RECORDING_PREVIEW = 'SET_TRAINING_CHILD_RECORDING_PREVIEW';

export const DOWNLOAD_TRAINING_RECORDING = 'DOWNLOAD_TRAINING_RECORDING';
export const DOWNLOAD_TRAINING_RECORDING_SUCCESS = 'DOWNLOAD_TRAINING_RECORDING_SUCCESS';
export const DOWNLOAD_TRAINING_RECORDING_ERROR = 'DOWNLOAD_TRAINING_RECORDING_ERROR';
export const SET_TRAINING_RECORDING_PROGRESS = 'SET_TRAINING_RECORDING_PROGRESS';

export const UPDATE_TRAINING_COMMENTS = 'UPDATE_TRAINING_COMMENTS';
export const UPDATE_TRAINING_STATUS = 'UPDATE_TRAINING_STATUS';

export const CHANGE_TRAINING_VALUE = 'CHANGE_TRAINING_VALUE';
export const CHANGE_TRAINING_SEVERAL_VALUES = 'CHANGE_TRAINING_SEVERAL_VALUES';
export const RESET_TRAINING_STORE = 'RESET_TRAINING_STORE';

export const getTrainingRecordingsAction = (params, actions = {}) => {
  return async dispatch => {
    dispatch({ type: GET_TRAINING_RECORDINGS });
    try {
      const response = await getTrainingRecordings(params);
      const { success, results } = response;
      if (success) {
        dispatch({ type: GET_TRAINING_RECORDINGS_SUCCESS, payload: results, params });
        actions.onSuccess && actions.onSuccess(results);
      }
    } catch (error) {
      dispatch({ type: GET_TRAINING_RECORDINGS_ERROR });
      actions.onError && actions.onError(error.message);
    }
  };
};

export const setTrainingRecordingPreview = (uuid, preview) => ({
  type: SET_TRAINING_RECORDING_PREVIEW,
  payload: { uuid, preview },
});

export const setTrainingChildRecordingPreview = (parentUuid, childUuid, preview) => ({
  type: SET_TRAINING_CHILD_RECORDING_PREVIEW,
  payload: { parentUuid, childUuid, preview },
});

export const getDownloadLinkAction = (uuid, actions = {}) => {
  return async () => {
    try {
      const response = await getDownloadLink(uuid);
      const { success } = response;
      if (success) {
        actions.onSuccess && actions.onSuccess(response);
      }
    } catch (error) {
      actions.onError && actions.onError(error.message);
    }
  };
};

export const downloadRecordingAction = (url, uuid, name, actions = {}) => {
  return async dispatch => {
    const controller = new AbortController();
    dispatch({ type: DOWNLOAD_TRAINING_RECORDING, payload: { uuid, controller } });
    try {
      const response = await downloadRecording(
        url,
        controller.signal,
        _.throttle(progressEvent => {
          if (progressEvent.loaded && progressEvent.total) {
            dispatch({
              type: SET_TRAINING_RECORDING_PROGRESS,
              payload: { uuid, progress: Math.round((progressEvent.loaded / progressEvent.total) * 100) },
            });
          }
        }, 500)
      );
      const { success, results } = response;
      if (success) {
        dispatch({ type: DOWNLOAD_TRAINING_RECORDING_SUCCESS, payload: { uuid } });
        let video = URL.createObjectURL(results);
        const tag = document.createElement('a');
        tag.href = video;
        tag.download = name;
        tag.click();
      }
    } catch (error) {
      console.log(error);
      actions.onError && actions.onError(error.message);
      dispatch({ type: DOWNLOAD_TRAINING_RECORDING_ERROR, payload: { uuid } });
    }
  };
};

export const deleteRecordingAction = (uuid, actions = {}) => {
  return async () => {
    try {
      const response = await deleteRecording(uuid);
      const { success, results } = response;
      if (success) {
        actions.onSuccess && actions.onSuccess(results);
      }
    } catch (error) {
      actions.onError && actions.onError(error.message);
    }
  };
};

export const updateStatus = (uuid, isProcessed) => ({
  type: UPDATE_TRAINING_STATUS,
  payload: { uuid, isProcessed },
});

export const updateComments = (uuid, commentsCount) => ({
  type: UPDATE_TRAINING_COMMENTS,
  payload: { uuid, commentsCount },
});

export const changeValue = (key, value) => ({
  type: CHANGE_TRAINING_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = value => ({
  type: CHANGE_TRAINING_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_TRAINING_STORE,
});
